export const NewChatBtnText = {
    en: "New Topic",
    hi: "नया विषय",
    or: "ନୂତନ ବିଷୟ",
    mr: "नवीन चॅट"
}

export const NewChatMessage = {
    en: "🌼 Your previous chat is complete. What would you like to ask about next?",
    hi: "🌼 पिछली चैट पूरी हुई। अब आप क्या पूछना चाहेंगी?",
    or: "🌼 ଆପଣଙ୍କର ପୂର୍ବ ଚାଟ୍ ସମ୍ପୂର୍ଣ୍ଣ ହୋଇଛି। ଆପଣ ପରବର୍ତ୍ତୀ ବିଷୟରେ କଣ ପଚାରିବାକୁ ଚାହାଁନ୍ତି?",
    mr: "🌼 मागील संभाषण पूर्ण झाले आहे. आता तुम्ही नवीन विषयाबद्दल विचारू शकता."
}

export const NewChatDisclaimer = {
    en: "New chat started",
    hi: "नई चैट शुरू हो गई है",
    or: "ଏକ ନୂତନ ଚାଟ୍ ଆରମ୍ଭ ହୋଇଛି",
    mr: "नवीन संभाषण सुरू झाल आहे"
}
